document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener("click", function (e) {
        var button = e.target.closest(".complementary-add-to-cart");

        if (button) {
            var form = button.closest(".complementary-add-to-cart-form");
            if (!form) return;

            e.preventDefault();
            e.stopImmediatePropagation();


            // Only dispatch the theme's standard event to trigger cart update logic
            document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                    detail: { button: button },
                    bubbles: false
                })
            );
        }
    });
});